import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BSKT_DotHoc } from '../../services/dot_hoc/DotHocModels';

interface DotHocState {
    listData: BSKT_DotHoc[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    selectedId: number | null;
    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: BSKT_DotHoc;
}

const initialState: DotHocState = {
    listData: [],
    status: 'idle',
    selectedId: null,
    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: {
        Den_ngay: '',
        ID_dot_hoc: 0,
        Dot: 0,
        Nam_tuyen_sinh: 0,
        Ten_dot: '',
        Tu_ngay: '',
        Ghi_chu: ''
    }
};

const dotHocSlice = createSlice({
    name: 'dotHoc',
    initialState,
    reducers: {
        setList: (state, action: PayloadAction<BSKT_DotHoc[]>) => {
            state.listData = action.payload;
        },
        setStatus: (state, action: PayloadAction<DotHocState['status']>) => {
            state.status = action.payload;
        },
        selectDotHoc: (state, action: PayloadAction<number>) => {
            state.selectedId = action.payload;
        },
        setCreateOrEditModel: (state, action: PayloadAction<BSKT_DotHoc>) => {
            state.isShowCreateOrEditModal = true;
            state.createOrEditModel = action.payload;
        },
        setShowCreateOrEditModal: (state, action: PayloadAction<boolean>) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setShowConfirmDeleteModal: (state, action: PayloadAction<number>) => {
            state.isShowConfirmDeleteModal = true;
            state.selectedId = action.payload;
        },
        insertSuccess: (state, action: PayloadAction<BSKT_DotHoc>) => {
            state.listData.push(action.payload);
            state.isShowCreateOrEditModal = false;
        },
        updateSuccess: (state, action: PayloadAction<BSKT_DotHoc>) => {
            const index = state.listData.findIndex((item) => item.ID_dot_hoc === action.payload.ID_dot_hoc);
            if (index !== -1) {
                state.listData[index] = action.payload;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteSuccess: (state, action: PayloadAction<number>) => {
            state.listData = state.listData.filter((item) => item.ID_dot_hoc !== action.payload);
            state.isShowConfirmDeleteModal = false;
            if (state.selectedId === action.payload) {
                state.selectedId = null;
            }
        },
        resetState: () => initialState
    }
});

export const {
    setList,
    setStatus,
    selectDotHoc,
    setCreateOrEditModel,
    setShowCreateOrEditModal,
    setShowConfirmDeleteModal,
    insertSuccess,
    updateSuccess,
    deleteSuccess,
    resetState
} = dotHocSlice.actions;

export const dotHocReducer = dotHocSlice.reducer;
